import { render } from "./PWAInstallPrompt.vue?vue&type=template&id=037baca7&scoped=true"
import script from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&lang=js"

import "./PWAInstallPrompt.vue?vue&type=style&index=0&id=037baca7&scoped=true&lang=css"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037baca7"],['__file',"PWAInstallPrompt.vue"]])

export default __exports__